import {Component, Input} from '@angular/core';

import {HelpBuyItemComponent} from "./components/help-buy-item/help-buy-item.component";
import {HelpBidComponent} from "./components/help-bid/help-bid.component";
import {HelpSendOfferComponent} from "./components/help-send-offer/help-send-offer.component";
import {HelpManageOffersComponent} from "./components/help-manage-offers/help-manage-offers.component";
import {HelpContactSellerComponent} from "./components/help-contact-seller/help-contact-seller.component";
import {HelpContactBuyerComponent} from "./components/help-contact-buyer/help-contact-buyer.component";

@Component({
    selector: 'nz-purchases-sales',
    imports: [
        HelpBuyItemComponent,
        HelpBidComponent,
        HelpSendOfferComponent,
        HelpManageOffersComponent,
        HelpContactSellerComponent,
        HelpContactBuyerComponent
    ],
    templateUrl: './purchases-sales.component.html',
    styleUrl: './purchases-sales.component.scss'
})
export class PurchasesSalesComponent {
  @Input() subsectionId?: number;
}
